// src/app/hikayeGirisi.ts
//
// «Oluştur» menüsündeki HİKAYE maddesinin gerçek hedefi.
//
// ── ÖLÇÜLEN KUSUR (P0-4) ─────────────────────────────────────────────────
// `CreateMenu.handleStoryClick` şunu yapıyordu:
//     onClose(); document.getElementById("hikaye-upload")?.click();
// `?.` yüzünden eleman yoksa tıklama SESSİZCE hiçbir şey yapmıyordu.
//
// ── ÖLÇÜM: AKIŞ ÜRÜNDE VAR MI? (karar tahminle değil, sayımla) ───────────
//   grep -rn "hikaye-upload" src/  → 3 isabet:
//     · `CreateMenu.tsx:123`  (çağıran)
//     · `Hikayeler.tsx:904`   (şeritteki "+" düğmesi, aynı elemanı tıklıyor)
//     · `Hikayeler.tsx:912`   (`<input id="hikaye-upload" …>` — GERÇEK hedef)
//   `Hikayeler` NEREDE render ediliyor? → `App.tsx:1118`, ve KOŞULLU:
//     `{activePage === "home" && ( … <Hikayeler …/> … )}`
//   Yükleme hattı da var: `Hikayeler.handleHikayeEkle` + `components/
//   StoryComposer.tsx` + `StoryModal*`.
// ⇒ HÜKÜM: hikaye yükleme akışı ÜRÜNDE VAR; düğme ölü DEĞİL, YALNIZ
//   ana sayfa DIŞINDA ölü (denetim profil sayfasında ölçtüğü için "ölü"
//   göründü). Doğru onarım kaldırmak değil, GERÇEK HEDEFE BAĞLAMAK.
//
// ── NEDEN YOKLAMA (tek seferlik `getElementById` DEĞİL) ──────────────────
// Menüden seçince önce ana sayfaya geçilir; `Hikayeler` şeridi o commit'te
// henüz DOM'da değildir. Tek seferlik arama yine sessizce boşa düşerdi.
// Bütçe sonunda eleman hâlâ yoksa sonuç `"bulunamadi"` döner — çağıran bunu
// KULLANICIYA SÖYLER. Sessiz başarısızlık, düzeltilen kusurun kendisiydi;
// onu yeni bir yerde tekrarlamak onarımı geri almak olurdu.
//
// ⚠️ Tarayıcı KISITI (ölçülemedi, dürüstçe yazılıyor): dosya seçicisini
// programatik `click()` ile açmak kullanıcı etkileşimi penceresine bağlıdır.
// Bütçe kasten kısa (varsayılan 1.5 sn) — Chrome'un geçici etkileşim
// penceresi (~5 sn) içinde kalır. Gerçek cihazda (özellikle iOS Safari)
// doğrulanmadı; bu turda ölçüm aracı yoktu.

export const HIKAYE_GIRIS_ID = "hikaye-upload";

export type HikayeGirisSonucu = "acildi" | "bulunamadi";

export type HikayeGirisSecenekleri = {
  /** Enjekte edilebilir belge (test + SSR güvenliği). */
  belge?: Document | null;
  /** Toplam yoklama bütçesi (ms). */
  butceMs?: number;
  /** Yoklama adımı (ms). */
  adimMs?: number;
  /** Enjekte edilebilir bekleme (testte sahte zaman). */
  bekle?: (ms: number) => Promise<void>;
};

export async function hikayeYuklemeyiAc({
  belge = typeof document !== "undefined" ? document : null,
  butceMs = 1500,
  adimMs = 50,
  bekle = (ms: number) => new Promise<void>((r) => { setTimeout(r, ms); }),
}: HikayeGirisSecenekleri = {}): Promise<HikayeGirisSonucu> {
  if (!belge) return "bulunamadi";
  const adimSayisi = Math.max(1, Math.ceil(butceMs / Math.max(1, adimMs)));
  for (let i = 0; i < adimSayisi; i += 1) {
    const el = belge.getElementById(HIKAYE_GIRIS_ID) as HTMLElement | null;
    if (el) {
      try { el.click(); } catch { return "bulunamadi"; }
      return "acildi";
    }
    // eslint-disable-next-line no-await-in-loop
    await bekle(adimMs);
  }
  return "bulunamadi";
}
